export const SUCCESS_RESPONSES = {
  NOT_YET: { label: 'Not yet', value: 'not_yet' },
  PARTLY: { label: 'Partly', value: 'partly' },
  YES: { label: 'Yes', value: 'yes' },
};

export const ANALYTICS_CONSTANTS = {
  PAGE_NAME: 'Chunkview',
};
